import { clientPath, lpRequest } from '../../../../core/utils/lp-backend';
import { getUser } from './get-user';

/** `PUT /client/:cid/users/:id/scopes {scopes}`. */
export const editUserScopes = async (user_id: string, scopes: string[]): Promise<any> => {
  await lpRequest('PUT', clientPath(`/users/${user_id}/scopes`), {
    body: { scopes: Array.isArray(scopes) ? scopes : [] }
  });

  return getUser(user_id);
};
